module.exports = __webpack_public_path__ + "img/welcome_opt.a9353727.jpg";